
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/herkunft/tourismus",
      function () {
        return require("private-next-pages/herkunft/tourismus.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/herkunft/tourismus"])
      });
    }
  